/**
 * Notification Redux Reducer
 */

import * as update from 'immutability-helper';
import { reducerWithInitialState } from 'typescript-fsa-reducers';
import * as actions from '../actions/notifications';

type ReducerState = INotificationsState;
type Handler<K = undefined> = ReducerHandler<ReducerState, K>;

const initialState: ReducerState = [];

const pushNotificationHandler: Handler<INotificationProps> = (state, payload) => [...state, payload];
const consumeNotificationHandler: Handler = (state) => update(state, { $splice: [[0, 1]] });

export default reducerWithInitialState(initialState)
  .case(actions.pushNotification, pushNotificationHandler)
  .case(actions.consumeNotification, consumeNotificationHandler);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/redux/reducers/notifications.ts